export default "__VITE_ASSET__dNQNAjDW__"